import { create } from "zustand";

const useModalStore = create((set) => ({
  isPeriodFilterModal: false,
  setIsPeriodFilterModal: (value) => {
    set({ isPeriodFilterModal: value });
  },
}));

export default useModalStore;
